module.exports = __webpack_public_path__ + "static/media/module2.f36bd15e.png";